<template>
  <section class="content__result">
    <div id="contentManual" class="content__result">
      <div class="content__result_options-row d-flex justify-content-end">
        <SearchField
          class="search-field col-auto"
          :translate="{
            placeholder: $t('knowledge.product.search-placeholder'),
            tooltip: $t('knowledge.product.search-tooltip'),
          }"
          updated-value=""
          @launch-search="$emit('launch-search', $event)"
        />
        <ArchiveBulkActionRow
          class="search-field"
          :selected-contents="selectedContents"
          @restore="$emit('bulk-restore', selectedContents)"
          @delete="edit.delete = true"
        />
      </div>
      <ContentList
        :contents="contents"
        :contentListShow="true"
        :selected-contents="selectedContents"
        :moreOptions="moreOptions"
        :has-custom-label="true"
        item-type="archive"
        class="col-12 pb-4"
        @focus-content="$emit('focus-content', $event)"
        @restore="$emit('bulk-restore', $event)"
        @delete="bulkDelete(true, $event)"
        @display-more-options="displayMoreSolutions"
        @update-selected-contents="selectedContents = $event"
      >
        <template v-slot:label-tag="{ labelTag }">
          <span v-if="labelTag.isFromCase">
            <el-tooltip
              :content="generateTooltipMessage(labelTag.deletedCaseFromLabel)"
              placement="top"
            >
              <font-awesome-icon
                class="label-tag_warning ml-2"
                :icon="['fal', 'exclamation-square']"
              />
            </el-tooltip>
          </span>
        </template>
      </ContentList>
      <div
        v-if="contents.length === 0"
        class="d-flex align-items-center justify-content-center"
      >
        <img src="~assets/empty-contents.svg" />
      </div>
    </div>
    <DangerDeleteModal
      v-if="edit.delete"
      :display="edit.delete"
      type="archive"
      to-delete-name="SELECTED-CONTENTS"
      @choice="bulkDelete"
      @close="edit.delete = false"
    />
  </section>
</template>

<script>
import SearchField from '@/components/SearchField';
import ContentList from './ContentList';
import ArchiveBulkActionRow from './ArchiveBulkActionRow';
import DangerDeleteModal from '@/components/Modals/DangerDeleteModal';

export default {
  name: 'archive-list-section',
  components: {
    SearchField,
    ContentList,
    ArchiveBulkActionRow,
    DangerDeleteModal,
  },
  props: {
    contents: Array,
    moreOptions: Boolean,
  },
  data() {
    return {
      selectedContents: [],
      edit: {
        delete: false,
        products: false,
      },
    };
  },
  methods: {
    generateTooltipMessage(caseLabel) {
      return this.$t('knowledge.archives.archived-through', {
        case: caseLabel,
      });
    },
    displayMoreSolutions() {
      this.$emit('display-more-solutions');
    },
    bulkDelete(choice, contents = []) {
      if (choice) {
        let toDelete = contents.length ? contents : this.selectedContents;
        this.$emit('bulk-delete', toDelete);
        this.edit.delete = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content__result,
.content__result__item-row {
  width: 100%;

  a .content__result__link {
    margin-top: 2px;
    margin-bottom: 2px;
    width: 100%;
    color: $grey-9-mayday;

    &:hover {
      background-color: $grey-1-mayday;
      border-radius: 2px;
    }
  }

  :deep() .content-label-span {
    padding: 0px 8px;
  }

  :deep() .content-list-item-from-case {
    color: $grey-5-mayday;
    font-style: italic;
  }

  .label-tag_warning {
    color: $red-mayday;
  }
}
</style>
